function GraphConnectionCard({
    statusLoading,
    statusError,
    graphStatus,
    connecting,
    disconnecting,
    onConnect,
    onDisconnect,
}) {
    const connected = Boolean(graphStatus?.connected);

    return (
        <section className="crm-conv-graph-card">
            <header className="crm-conv-graph-header">
                <h3>Microsoft 365</h3>
                <span className={`crm-conv-graph-badge ${connected ? "is-connected" : "is-disconnected"}`}>
                    {connected ? "Connected" : "Disconnected"}
                </span>
            </header>

            {statusLoading ? <p className="crm-conv-graph-text">Checking connection...</p> : null}
            {!statusLoading && statusError ? <p className="crm-conv-graph-error">{statusError}</p> : null}
            {!statusLoading && !statusError ? (
                <p className="crm-conv-graph-text">
                    {connected
                        ? "Your account is linked. Email sync APIs can now use server-side Graph tokens."
                        : "Link your Microsoft account to enable email sync and scheduling features."}
                </p>
            ) : null}

            <div className="crm-conv-graph-actions">
                {!connected ? (
                    <button
                        type="button"
                        className="crm-conv-graph-connect-button"
                        onClick={onConnect}
                        disabled={statusLoading || connecting}
                    >
                        {connecting ? "Connecting..." : "Connect Microsoft"}
                    </button>
                ) : (
                    <button
                        type="button"
                        className="crm-conv-graph-disconnect-button"
                        onClick={onDisconnect}
                        disabled={statusLoading || disconnecting}
                    >
                        {disconnecting ? "Disconnecting..." : "Disconnect"}
                    </button>
                )}
            </div>
        </section>
    );
}

export default GraphConnectionCard;
